import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import type * as React from "react";
import { cn } from "../lib/utils";

const Tabs = TabsPrimitive.Root;

function TabsList({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
  ref?: React.Ref<React.ComponentRef<typeof TabsPrimitive.List>>;
}) {
  return (
    <TabsPrimitive.List
      ref={ref}
      // Radix parity: Radix activated tabs as arrow-key focus moved; Base UI
      // defaults to manual activation (Enter/Space). Restore automatic activation.
      activateOnFocus
      className={cn(
        "inline-flex h-8 items-center justify-center gap-0.5 rounded-lg bg-grayA-3 p-0.5 text-gray-11 shadow-[inset_0_0_0_1px_var(--color-grayA-3)]",
        className,
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Tab> & {
  ref?: React.Ref<React.ComponentRef<typeof TabsPrimitive.Tab>>;
}) {
  return (
    <TabsPrimitive.Tab
      ref={ref}
      className={cn(
        "inline-flex h-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-2.5 text-sm font-medium transition-[color,background-color,box-shadow] duration-150 outline-hidden focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-(--focus-ring) disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 hover:text-gray-12 data-active:bg-gray-12 data-active:text-gray-1 data-active:shadow-xs [&_svg]:size-3.5",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Panel> & {
  ref?: React.Ref<React.ComponentRef<typeof TabsPrimitive.Panel>>;
}) {
  return (
    <TabsPrimitive.Panel
      ref={ref}
      className={cn(
        "mt-2 outline-hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--focus-ring) rounded-md",
        className,
      )}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
